import { css } from '@/styled-system/css';

export const showMoreContentStack = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
});
